'use client';
import { faBars } from '@fortawesome/pro-solid-svg-icons';
import { useState } from 'react';
import { Icon, IconButton } from '@/components/ui';
import useHeaderContent from '@/hooks/use-header-content';
import { useResolveThemeColor } from '@/hooks/use-resolve-theme-color';

import MobileMenuDrawer from './mobile-menu-drawer';

type Props = {
  logoSrc: string;
};

const MobileMenu = ({ logoSrc }: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const resolveThemeColor = useResolveThemeColor();
  const headerContent = useHeaderContent();
  const toolbarIconColor = resolveThemeColor(headerContent.mainRowTextColor ?? 'foreground');

  const toggleDrawer = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <IconButton
        aria-label="Open menu"
        className="block p-1.5 @xl:hidden"
        variant="light"
        onClick={toggleDrawer}
      >
        <Icon icon={faBars} size="lg" style={{ color: toolbarIconColor }} />
      </IconButton>
      <MobileMenuDrawer isOpen={isOpen} toggleDrawer={toggleDrawer} logoSrc={logoSrc} />
    </>
  );
};

export default MobileMenu;
